import React from "react"

import { Card, Container, Row, Col, Button, Badge } from "react-bootstrap"
import {
  FaPhone,
  FaClock,
  FaHeart,
  FaBrain,
  FaBone,
  FaEye,
  FaBaby,
  FaStethoscope,
  FaUserCheck,
  FaCalendarAlt,
  FaShieldAlt,
  FaHeadphones,
  FaPlay,
  FaStar,
  FaCheckCircle,
  FaFacebook,
  FaWhatsapp,
  FaInstagram,
  FaYoutube
} from "react-icons/fa"
import Footer from "./Footer"

export default function ServicesPage() {
  const services = [
    {
      icon: FaHeart,
      title: "Cardiology",
      description: "Heart and cardiovascular system care with experienced cardiologists",
      features: ["ECG Analysis", "Heart Disease Management", "Preventive Care"],
      gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
    },
    {
      icon: FaBrain,
      title: "Neurology",
      description: "Comprehensive neurological care for brain and nervous system conditions",
      features: ["Headache Treatment", "Neurological Disorders", "Brain Health"],
      gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
    },
    {
      icon: FaBone,
      title: "Orthopedics",
      description: "Bone, joint, and muscle care from certified orthopedic specialists",
      features: ["Joint Pain", "Sports Injuries", "Fracture Care"],
      gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    },
    {
      icon: FaEye,
      title: "Ophthalmology",
      description: "Complete eye care services from routine exams to complex procedures",
      features: ["Vision Testing", "Eye Diseases", "Surgical Procedures"],
      gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
    },
    {
      icon: FaBaby,
      title: "Pediatrics",
      description: "Specialized Aidify for infants, children, and adolescents",
      features: ["Child Development", "Vaccinations", "Pediatric Care"],
      gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
    },
    {
      icon: FaStethoscope,
      title: "General Medicine",
      description: "Primary care services for overall health and wellness",
      features: ["Health Checkups", "Chronic Disease", "Preventive Care"],
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
    },
  ]

  const processSteps = [
    {
      icon: FaPhone,
      title: "Call Us",
      description: "Contact our 24/7 helpline at +92 300 1243439",
      gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
    },
    {
      icon: FaUserCheck,
      title: "Assessment",
      description: "Our team assesses your needs and finds the right specialist",
      gradient: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    },
    {
      icon: FaCalendarAlt,
      title: "Booking",
      description: "We book your appointment with the most suitable doctor",
      gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
    },
    {
      icon: FaHeadphones,
      title: "Follow-up",
      description: "We ensure you receive proper care and follow-up support",
      gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
    },
  ]

  return (
    <div className="min-vh-100">
      {/* Hero Section */}
      <section
        className="position-relative overflow-hidden py-5"
        style={{
          background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
          minHeight: "70vh",
        }}
      >
        {/* Animated Background Elements */}
        {/* <div className="position-absolute w-100 h-100">
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "250px",
              height: "250px",
              background: "white",
              top: "15%",
              right: "10%",
              animation: "float 6s ease-in-out infinite",
            }}
          ></div>
          <div
            className="position-absolute rounded-circle opacity-10"
            style={{
              width: "180px",
              height: "180px",
              background: "white",
              bottom: "20%",
              left: "8%",
              animation: "float 8s ease-in-out infinite reverse",
            }}
          ></div>
        </div> */}

        <Container className="position-relative">
          <div className="text-center text-white py-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <FaStethoscope className="me-2" />
              <span className="fw-medium">Our Services</span>
            </div>

            <h1 className="display-3 fw-bold mb-4">Aidify Services</h1>
            <p className="fs-5 mb-5 opacity-90" style={{ maxWidth: "700px", margin: "0 auto", lineHeight: "1.6" }}>
              Comprehensive medical services connecting you with top specialists across all Aidify domains
            </p>
            
            <a href="tel:+923001243439">    
            <Button
              size="lg"
              className="px-5 py-3 rounded-pill fw-bold border-0 me-3"
              style={{
                background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                boxShadow: "0 8px 25px rgba(220, 38, 38, 0.4)",
                transform: "translateY(0)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-3px)"
                e.target.style.boxShadow = "0 12px 35px rgba(220, 38, 38, 0.5)"
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)"
                e.target.style.boxShadow = "0 8px 25px rgba(220, 38, 38, 0.4)"
              }}
            >
              <FaPhone className="me-2" />
              Call Now: +92 300 1243439
            </Button>
            </a>

            {/* <Button
              size="lg"
              variant="outline-light"
              className="px-5 py-3 rounded-pill fw-bold"
              style={{
                borderWidth: "2px",
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              }}
            >
              <FaPlay className="me-2" />
              Watch Demo
            </Button> */}
          </div>
        </Container>
      </section>

      {/* Emergency Banner */}
      <section
        className="py-4"
        style={{
          background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
        }}
      >
        <Container>
          <Row className="align-items-center">
            <Col md={8}>
              <div className="d-flex align-items-center text-white">
                <div
                  className="rounded-circle me-3 d-flex align-items-center justify-content-center"
                  style={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    animation: "pulse 2s infinite",
                  }}
                >
                  <FaClock size={24} />
                </div>
                <div>
                  <h3 className="h5 fw-bold mb-1">24/7 Emergency Services</h3>
                  <p className="mb-0 opacity-90">Urgent medical attention available around the clock</p>
                </div>
              </div>
            </Col>
            <Col md={4} className="text-end">
              <Button
                      as="a"
                      href="tel:+923001243439"
                      variant="light"
                      className="px-4 py-2 rounded-pill fw-bold"
                      style={{
                        // background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                        // boxShadow: "0 8px 25px rgba(8, 145, 178, 0.4)",
                        color: "#dc2626",
                      }}
                    >
                     Call Now
                    </Button>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Services Grid */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          <div className="text-center mb-5">
            <div
              className="d-inline-flex align-items-center px-4 py-2 rounded-pill mb-4"
              style={{
                background: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
                color: "white",
              }}
            >
              <FaStar className="me-2" />
              <span className="fw-medium">Medical Specialties</span>
            </div>

            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Expert Care Across All Specialties
            </h2>
            <p className="fs-5 text-muted" style={{ maxWidth: "600px", margin: "0 auto" }}>
              Our network of specialists provides comprehensive care for all your health needs
            </p>
          </div>

          <Row className="g-4">
            {services.map((service, index) => (
              <Col md={6} lg={4} key={index}>
                <Card
                  className="h-100 border-0 rounded-4 overflow-hidden"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    animationDelay: `${index * 0.1}s`,
                    animation: "fadeInUp 0.8s ease forwards",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <Card.Body className="p-4">
                    <div
                      className="rounded-circle mb-4 d-flex align-items-center justify-content-center"
                      style={{
                        width: "70px",
                        height: "70px",
                        background: service.gradient,
                        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                      }}
                    >
                      <service.icon size={28} className="text-white" />
                    </div>
                    <Card.Title className="h4 fw-bold mb-3" style={{ color: "#1f2937" }}>
                      {service.title}
                    </Card.Title>
                    <Card.Text className="text-muted mb-4" style={{ lineHeight: "1.6" }}>
                      {service.description}
                    </Card.Text>
                    <ul className="list-unstyled mb-4">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="d-flex align-items-center text-muted mb-2">
                          <FaCheckCircle style={{ color: "#059669" }} className="me-2" size={14} />
                          <small>{feature}</small>
                        </li>
                      ))}
                    </ul>
                    <Button
                      className="w-100 rounded-pill fw-medium border-0"
                      style={{
                        background: service.gradient,
                        boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
                        transform: "translateY(0)",
                        transition: "all 0.3s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "translateY(-2px)"
                        e.target.style.boxShadow = "0 6px 20px rgba(0, 0, 0, 0.3)"
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "translateY(0)"
                        e.target.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.2)"
                      }}
                    >
                      Book Appointment
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* How It Works */}
      <section className="py-5" style={{ backgroundColor: "white" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              How Our Service Works
            </h2>
            <p className="fs-5 text-muted">Simple steps to get the care you need</p>
          </div>

          <Row className="g-4">
            {processSteps.map((step, index) => (
              <Col md={6} lg={3} key={index}>
                <Card
                  className="text-center border-0 rounded-4 h-100"
                  style={{
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
                    transform: "translateY(0)",
                    transition: "all 0.4s ease",
                    backgroundColor: "#f0fdfa",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)"
                    e.currentTarget.style.boxShadow = "0 20px 60px rgba(0, 0, 0, 0.15)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = '0 10px 40px rgba(0, : "translateY(0)'
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.1)"
                  }}
                >
                  <Card.Body className="p-4">
                    <div className="position-relative mb-4">
                      <div
                        className="rounded-circle mx-auto d-flex align-items-center justify-content-center"
                        style={{
                          width: "80px",
                          height: "80px",
                          background: step.gradient,
                          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
                        }}
                      >
                        <step.icon size={32} className="text-white" />
                      </div>
                      <Badge
                        className="position-absolute top-0 end-0 rounded-circle fw-bold"
                        style={{
                          width: "30px",
                          height: "30px",
                          background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
                          border: "3px solid white",
                          transform: "translate(25%, -25%)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {index + 1}
                      </Badge>
                    </div>
                    <Card.Title className="h5 fw-bold mb-3" style={{ color: "#1f2937" }}>
                      {step.title}
                    </Card.Title>
                    <Card.Text className="text-muted">{step.description}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Features Section */}
      <section className="py-5" style={{ backgroundColor: "#f8fffe" }}>
        <Container>
          <div className="text-center mb-5">
            <h2 className="display-6 fw-bold mb-4" style={{ color: "#1f2937" }}>
              Why Choose Our Services?
            </h2>
            <p className="fs-5 text-muted">Excellence in every aspect of Aidify delivery</p>
          </div>

          <Row className="g-4">
            {[
              {
                icon: FaShieldAlt,
                title: "Licensed Professionals",
                description: "All our partner doctors are licensed and verified Aidify professionals",
                gradient: "linear-gradient(135deg, #0891b2 0%, #0e7490 100%)",
              },
              {
                icon: FaClock,
                title: "Quick Response",
                description: "Average appointment booking time is under 15 minutes",
                gradient: "linear-gradient(135deg, #059669 0%, #047857 100%)",
              },
              {
                icon: FaHeart,
                title: "Personalized Care",
                description: "Tailored Aidify solutions based on your specific needs",
                gradient: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
              },
            ].map((feature, index) => (
              <Col md={4} key={index}>
                <div
                  className="d-flex p-4 rounded-4"
                  style={{
                    backgroundColor: "white",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    transform: "translateY(0)",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)"
                    e.currentTarget.style.boxShadow = "0 15px 50px rgba(0, 0, 0, 0.12)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)"
                    e.currentTarget.style.boxShadow = "0 10px 40px rgba(0, 0, 0, 0.08)"
                  }}
                >
                  <div
                    className="rounded-circle me-4 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "60px",
                      height: "60px",
                      background: feature.gradient,
                      boxShadow: "0 8px 25px rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    <feature.icon size={24} className="text-white" />
                  </div>
                  <div>
                    <h3 className="h5 fw-bold mb-2" style={{ color: "#1f2937" }}>
                      {feature.title}
                    </h3>
                    <p className="text-muted mb-0" style={{ lineHeight: "1.6" }}>
                      {feature.description}
                    </p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

    <Footer/>

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
          }
          70% {
            box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
          }
        }
      `}</style>
    </div>
  )
}
